export type ApiResponse<T> = { data: T; meta?: { page: number; per_page: number; total: number; last_page: number } }

const base = import.meta.env.VITE_API_BASE || '/api'
let token = sessionStorage.getItem('admin_token') || ''
const requestId = () => globalThis.crypto?.randomUUID?.() ?? `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
export function setToken(value: string) { token = value; value ? sessionStorage.setItem('admin_token', value) : sessionStorage.removeItem('admin_token') }
export async function api<T>(path: string, options: RequestInit = {}): Promise<ApiResponse<T>> {
  const headers = new Headers(options.headers)
  headers.set('Accept', 'application/json')
  headers.set('X-Request-Id', requestId())
  if (token) headers.set('Authorization', `Bearer ${token}`)
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type', 'application/json')
  const response = await fetch(`${base}${path}`, { ...options, headers })
  const body = await response.json().catch(() => ({ error: { message: '服务响应无效' } }))
  if (!response.ok) {
    if (response.status === 401) { setToken(''); window.dispatchEvent(new Event('session-expired')) }
    throw new Error(body.error?.message || '请求失败')
  }
  return body
}
export const get = <T>(path: string) => api<T>(path)
export const post = <T>(path: string, data?: unknown) => api<T>(path, { method: 'POST', body: data instanceof FormData ? data : JSON.stringify(data || {}) })
export const put = <T>(path: string, data?: unknown) => api<T>(path, { method: 'PUT', body: JSON.stringify(data || {}) })
export const patch = <T>(path: string, data?: unknown) => api<T>(path, { method: 'PATCH', body: JSON.stringify(data || {}) })
export const del = <T>(path: string) => api<T>(path, { method: 'DELETE' })
